import React, { useEffect, useState } from 'react';
import ApplicationInformation from './ApplicationInformation';
import CourseInformation from './CourseInformation';
import CoursePayment from './Payment';
import Steps from './Steps';
import store from '../../redux/Store';
import { Form } from 'antd';
import { HppPayment } from '../../utils/checkout';
import { useSelector } from 'react-redux';
import { intialStepData } from './json';
import RouterPrompt from '../../component/RouterPrompt';
import RetryPop from './RetryPop';
import CustomModal from '../../hoc/CustomModal';
import {countries, states} from './json'

const iniState = {
  start_date: '',
  first_name: '',
  last_name: '',
  middle_name: '',
  preffered_name: '',
  email: '',
  date_of_birth: '',
  address: '',
  address2: '',
  city: '',
  state: '',
  country: '',
  zip_code: '',
  home_phone: '',
  cell_phone: '',
  gender: '',
  demographic_info: '',
  residency: '',
  parent_information: [
    {
      Parent_guardian_1: []
    }
  ],
  highschool_information: []
};

function ApplicationRegistration({ match }) {
  const [form] = Form.useForm();
  const [courseForm] = Form.useForm();
  const [stepNumber, setStepNumber] = useState(1);
  const [otherOption, setOtherOption] = useState({});
  const [formData, setFormData] = useState({});
  const [interestFile, setIntrestFile] = useState('');
  const [gradesFile, setGradesFile] = useState('');
  const [gradeLoader, setGradeLoader] = useState(false);
  const [interestLoader, setInterestLoader] = useState(false);
  const allOptions = useSelector((state) => state.ApplicationModel.courses);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [retryPop, setRetryPop] = useState(false);
  const [payload, setPayload] = useState({});
  const [ statusFrom , setSatatusFrom] = useState({step2:false , step3:false })
  const [userResponse, setUserResponse] = useState(false)
  const [formSubmit, setformSubmit] =useState(false)
  const [fstep, setFstep] = useState(false)

  const applicationLoading = useSelector(
    (state) => state.loading.effects.CourseModel.userApplication
  );
  const selectLoading = useSelector(
    (state) => state.loading.effects.ApplicationModel.getAllCourse
  );
  const tokenLoading = useSelector(
    (state) => state.loading.effects.ApplicationModel.getPaymentToken
  );
  const userData = useSelector((state) => state.ApplicationModel.applicatio_id);
  const { dispatch } = store;

  
  useEffect(() => {
    dispatch.ApplicationModel.getAllCourse();
  }, []);


  useEffect(()=>{ 
    if(formSubmit){
      if(userResponse && fstep){
        setStepNumber(stepNumber + 1);
        setformSubmit(false)
        let eventcall = 1;
        if(eventcall === 1 && eventcall !== 2 && !statusFrom.step2){
          dispatch.ApplicationModel.preClgEvent({
            ["event"]: 'Application Step 2',
            email:userData.email,
            user_id:userData._id,
            course_id:userData.course_id
          });
          eventcall += 1;
          setSatatusFrom({...statusFrom,step2:true})
        }
      }
    }
  },[formSubmit, userResponse ,fstep])

  console.log("setUserResponse",formSubmit, userResponse ,fstep)

  useEffect(() => {
    if (allOptions.allCourse.length > 0) {

      let selectedCourse = allOptions.allCourse.filter(
        (data) => data.courseId === match.params.id
      )[0];
      const currentDate = new Date();
      const filteredDates = selectedCourse?.start_date.filter(dateStr => {
        const date = new Date(dateStr);
        return date > currentDate;
      });
     
      dispatch.ApplicationModel.setCustomDates({
        name: 'courseDate',
        value: [...(filteredDates || [])]
      });
      
      form.setFieldsValue({ course_selection: { course_id: match.params.id } });
    }
  }, [match.params, allOptions.allCourse]);

  const handleUpload = (e, type) => {
    const config = {
      headers: { 'content-type': 'multipart/form-data' }
    };
    courseForm.setFieldValue(
      ['course_information', 'most_recently_completed'],
      ""
    );
    const fileData = new FormData();
    fileData.append('file', e.file);
    type === 'grades' ? setGradeLoader(true) : setInterestLoader(true);
    dispatch.fileUploadModel.uploadFileS3({
      fileData,
      config,
      setFile: handleSetFile,
      type,
      setLoader: type === 'grades' ? setGradeLoader : setInterestLoader
    });
  };

  const handleSetFile = (type, url) => {
    if (type === 'grades') {
      setGradesFile(url);
      courseForm.setFieldValue(
        ['course_information', 'most_recently_completed'],
        url
      );
    } else {
      courseForm.setFieldValue(
        ['course_information', 'most_recently_completed'],
        gradesFile
      );
      setIntrestFile(url);
    }
  };

  const handleDeleteUploads = (type) => {
    courseForm.setFieldValue(
      ['course_information', 'most_recently_completed'],
      ""
    );
    type === 'grades' ? setGradesFile('') : setIntrestFile('');
  };

  const onStepFinish = (values, step, rest) => {
    let temp = {};
    switch (step) {
      case 1:  
        // step event
      
        let course = allOptions?.allCourse?.filter(
          (data) => data.courseId === values.course_selection.course_id
        )[0];
        const countryCode = countries.find((e)=>e.value === values?.personal_information?.country)
        const counrtyValue= countries.find((x)=>x.value === values?.personal_information?.country)?.label;
        const stateValue= states.find((x)=>x.value === values?.personal_information?.state)?.label;
  
        dispatch.ApplicationModel.trackFormInAc({
          email: values?.personal_information?.email,
          country: counrtyValue,
          state: stateValue ?? "",
          firstname: values?.personal_information?.first_name,
          lastname: values?.personal_information?.last_name,
          phone: values?.personal_information?.cell_phone,
          sms:values?.personal_information?.sms,
          country_code : countryCode.code,
          coursename: course?.name,
          startdate: values?.course_selection?.start_date,
          formID: 'PreCollageApplicantForm',
        });
        setFormData({ ...formData, ...values });

        if(!fstep){
          setformSubmit(true)
          setFstep(1)
        }else{
          setStepNumber(stepNumber + 1);
        }
        // setStepNumber(stepNumber + 1);
        break;
      case 2:
        // step event 
        let eventcalls = 1
        if(eventcalls === 1 && eventcalls !== 2 && !statusFrom.step3){
          dispatch.ApplicationModel.preClgEvent({
            ["event"]: 'Application Step 3',
            email:userData.email,
            user_id:userData._id,
            course_id:userData.course_id
          });
          eventcalls += 1;
          setSatatusFrom({...statusFrom,step3:true})
        }
        temp = createPayload({ ...formData, ...values });
        //setFormData({ ...formData, ...values });
        dispatch.CourseModel.userApplication({ temp, setPayload, setStepNumber });
        // setStepNumber(stepNumber + 1);
        break;
      case 3:
        setSubmitLoader(true);
        setRetryPop(false);
        //dispatch.ApplicationModel.getPaymentToken({temp, setSubmitLoader, setRetryPop });
        //dispatch.CourseModel.userApplication({temp, setSubmitLoader, setRetryPop });
        dispatch.ApplicationModel.getPaymentToken({ temp: payload, setSubmitLoader, setRetryPop, usc_payment_id: payload?.application_id });
        break;
      default:
        return;
    }
  };

  const createPayload = (formData) => {
    const {
      parents_information_1,
      parents_information_2,
      personal_information,
      highschool_information,
      course_selection,
      course_information,
      gender,
      residency,
      identity,
      how_did_hear_about,
    } = formData;
    let current = allOptions?.allCourse?.filter(
      (data) => data.courseId === course_selection.course_id
    )[0];
    let identityData =
      otherOption?.['identity'] && identity
        ? [...(personal_information?.identity || []), identity]
        : personal_information.identity;
        let howHearData =
        otherOption?.['how_did_hear_about'] && how_did_hear_about
          ? [...(personal_information?.how_did_hear_about || []), how_did_hear_about]
          : personal_information.how_did_hear_about;
    
    let smsData  = personal_information.sms ? true : false
    const countryCode = countries.find((e)=>e.value === personal_information.country) 
    const stateHandel = states.find((e)=>e.value === personal_information.state) 
    
    let temp = {
      ...course_selection,
      course_id: current._id,
      ssl_description: current.name,
      ...personal_information,
      parent_information: {
        Parent_guardian_1: [{ ...parents_information_1,  parent_email: parents_information_1?.parent_email?.toLowerCase(), }],
        Parent_guardian_2: [{ ...parents_information_2, parent_email_2: parents_information_2?.parent_email_2?.toLowerCase(),}]
      },
      // highschool_information,
      highschool_information:{...highschool_information , counselor_email:highschool_information?.counselor_email?.toLowerCase(),},
      transaction_type: 'ccsale',
      amount: 35,
      course_information: {
        ...(course_information || {}),
        most_recently_completed: gradesFile,
        self_document: interestFile
      },
      payment_type: 'application',
      gender:
        otherOption?.['gender'] && gender
          ? gender
          : personal_information.gender,
      residency:
        otherOption?.['residency'] && residency
          ? residency
          : personal_information.residency,
      identity: identityData?.filter((value) => value !== 'other'),
      how_did_hear_about: howHearData?.filter((value) => value !== 'other'),
      email:personal_information.email?.toLowerCase(),
      sms:smsData,
      state:stateHandel?.label,
      country_code:countryCode.code,
      user_id:userData?._id
    };
    if (payload?.application_id) {
      temp = {...temp, application_id: payload?.application_id }
    }
    return temp
  }

  const stepChanger = (step) => {
    switch (step) {
      case 1:
        setStepNumber(step);
        break;
      case 2:
        virifyFirstStep(step);
        break;
      case 3:
        if (stepNumber === 1) {
          dispatch.ErrorModel.handleErrorPop({
            header: 'Info',
            body: 'Please complete 2 step.'
          });
          return;
        }
        courseForm
          .validateFields()
          .then((res) => {
            if (
              JSON.stringify(formData) !==
              JSON.stringify({ ...formData, ...res }) &&
              Object.keys(res).length > 1
            ) {
              courseForm.submit();
            } else {
              courseForm.setFieldsValue(formData);
            }
            virifyFirstStep(step);
          })
          .catch((err) => {
            dispatch.ErrorModel.handleErrorPop({
              header: 'Info',
              body: 'Please fill all the required details to proceed to next step'
            });
          });
        break;
      default:
        return;
    }
  };

  const virifyFirstStep = (step) => {
    
    form
      .validateFields()
      .then((res) => {
        if (
          JSON.stringify(formData) !==
          JSON.stringify({ ...formData, ...res }) &&
          Object.keys(res).length > 1
        ) {   
          form.submit();
        } else {
          form.setFieldsValue(formData);
        }
        setStepNumber(step);
      })
      .catch((err) => {
        dispatch.ErrorModel.handleErrorPop({
          header: 'Info',
          body: 'Please fill all the required details to proceed to next step'
        });
      });
  };

  const renderView = () => {
    switch (stepNumber) {
      case 2:
        return (
          <CourseInformation
            setFormData={setFormData}
            formData={formData}
            setStepNumber={setStepNumber}
            form={courseForm}
            Form={Form}
            onStepFinish={onStepFinish}
            handleUpload={handleUpload}
            interestFile={interestFile}
            gradesFile={gradesFile}
            gradeLoader={gradeLoader}
            interestLoader={interestLoader}
            handleDeleteUploads={handleDeleteUploads}
            applicationLoading={applicationLoading}
            dispatch={dispatch}
          />
        );
      case 3:
        return (
          <CoursePayment
            submitLoader={submitLoader}
            tokenLoading={tokenLoading}
            allOptions={allOptions}
            formData={formData}
            onStepFinish={onStepFinish}
            dispatch={dispatch}
          />
        );
      default:
        return (
          <ApplicationInformation
            formData={formData}
            onStepFinish={onStepFinish}
            allOptions={allOptions}
            selectLoading={selectLoading}
            dispatch={dispatch}
            setOtherOption={setOtherOption}
            otherOption={otherOption}
            form={form}
            Form={Form}
            setUserResponse={setUserResponse}
            userResponse={userResponse}
            formSubmit={formSubmit}
          />
        );
    }
  };

  return (
    <div className='course_payment_tab'>
      <div className='container'>
        <div className='course_tab'>
          <h2>USC Pre-College Programs Application </h2>
          <Steps stepChanger={stepChanger} stepNumber={stepNumber} />
          {renderView()}
        </div>
      </div>
      <RouterPrompt
        isBlocked={!submitLoader}
        title='registration is not complete'
        content='You are about to leave this page without completing your registration and will lose all the profile information added so far.'
      />
      <CustomModal
        handleOpen={() => setRetryPop(false)}
        open={retryPop}
      >
        <RetryPop
          updateCourse={() => onStepFinish("35", 3)}
          updateLoad={submitLoader || tokenLoading}
          tittle={'The system encountered an issue. Please try again.'}
        />
      </CustomModal>
    </div>
  );
}

export default ApplicationRegistration;
